/* ec-swatch-focus.js — deri swatch otomatik odak.
   Kart swatch'ları rengin gerçek ayakkabı karesinden kırpılır; ayakkabının kadrajdaki
   konumu modele göre değiştiği için sabit transform-origin beyaz fon/taban yakalayabiliyor.
   Bu script her swatch görselini 48x48 örnekleyip EN DOYGUN (deri) pencereyi bulur ve
   origin'i oraya kilitler. Shopify CDN CORS (*) verir; hata halinde CSS varsayılanı kalır. */
(function () {
  if (window.__ecSwatchFocus) return;
  window.__ecSwatchFocus = 1;

  var SCALE = 5;               /* ec-base .ec-prod-card__swatch--leather img scale ile senkron */
  var N = 48;                  /* örnekleme çözünürlüğü */
  var WIN = Math.round(N / SCALE); /* görünür pencere (kaynak px) */

  function scoreWindow(data, x0, y0) {
    /* pencere içi: doygun + koyu piksel oranı (deri); beyaz fon & soluk taban cezalı */
    var good = 0, total = 0;
    for (var y = y0; y < y0 + WIN; y += 2) {
      for (var x = x0; x < x0 + WIN; x += 2) {
        var i = (y * N + x) * 4;
        var r = data[i], g = data[i + 1], b = data[i + 2];
        var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
        var sat = mx - mn, lum = (r + g + b) / 3;
        total++;
        if (lum > 228) { good -= 3; continue; }   /* beyaz stüdyo fonu: ağır ceza */
        if (sat > 16 && lum < 215) good++;         /* doygun deri */
        else if (lum < 100) good++;                /* koyu deri (siyah) — eşdeğer */
      }
    }
    return good / total;
  }

  function focusOne(el) {
    var img = el.querySelector('img');
    if (!img || el.dataset.ecFocused) return;
    el.dataset.ecFocused = '1';
    var src = img.currentSrc || img.src;
    if (!src) return;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var c = document.createElement('canvas');
        c.width = N; c.height = N;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        /* object-fit cover eşleniği: kısa kenarı doldur */
        var s = Math.min(probe.naturalWidth, probe.naturalHeight);
        ctx.drawImage(probe, (probe.naturalWidth - s) / 2, (probe.naturalHeight - s) / 2, s, s, 0, 0, N, N);
        var data = ctx.getImageData(0, 0, N, N).data;
        var best = -1, bx = Math.round((N - WIN) / 2), by = bx;
        for (var y = 0; y <= N - WIN; y += 2) {
          for (var x = 0; x <= N - WIN; x += 2) {
            var sc = scoreWindow(data, x, y);
            if (sc > best) { best = sc; bx = x; by = y; }
          }
        }
        if (best > 0.35) {
          /* pencere merkezi → transform-origin yüzdesi */
          var ox = ((bx + WIN / 2) / N) * 100;
          var oy = ((by + WIN / 2) / N) * 100;
          img.style.transformOrigin = ox.toFixed(1) + '% ' + oy.toFixed(1) + '%';
        }
      } catch (e) { /* CORS/karalama hatası: CSS varsayılanı kalır */ }
    };
    probe.src = src;
  }

  /* TBT fix: yuk aninda IS YOK — swatch gorunur olunca idle diliminde tek tek islenir */
  var kuyruk = [];
  var pompaAktif = false;
  function pompa(deadline) {
    pompaAktif = true;
    while (kuyruk.length && (!deadline || deadline.timeRemaining() > 8)) {
      focusOne(kuyruk.shift());
    }
    if (kuyruk.length) {
      if (window.requestIdleCallback) requestIdleCallback(pompa, { timeout: 2000 });
      else setTimeout(function () { pompa(); }, 120);
    } else { pompaAktif = false; }
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (girisler) {
    var eklendi = false;
    girisler.forEach(function (g) {
      if (g.isIntersecting) { io.unobserve(g.target); kuyruk.push(g.target); eklendi = true; }
    });
    if (eklendi && !pompaAktif) {
      if (window.requestIdleCallback) requestIdleCallback(pompa, { timeout: 2000 });
      else setTimeout(function () { pompa(); }, 120);
    }
  }, { rootMargin: '200px' }) : null;
  function scan(root) {
    (root || document).querySelectorAll('.ec-prod-card__swatch--leather:not([data-ec-focused])').forEach(function (el) {
      if (io) io.observe(el);
      else { kuyruk.push(el); if (!pompaAktif) setTimeout(function () { pompa(); }, 200); }
    });
  }

  function boot() {
    scan(document);
    /* Load More / recommendations AJAX ile gelen kartlar */
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) scan(added[j]);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', function () { scan(document); });
})();
